import abd from './vendor/adBlockDetectionLib.js';

let detector;

export default {
	run() {
		return new Promise((resolve, reject) => {
			if (!abd.init) {
				reject(new Error('Failed to initialise adblock detection'));
				return;
			}

			if (typeof window === 'undefined' || typeof document === 'undefined') {
				resolve(false);
				return;
			}

			try {
				detector = detector || abd.init();
				detector({
					complete: resolve,
				});
			} catch (error) {
				reject(error);
			}
		});
	},
};
